import React, { useState, useRef, useEffect } from 'react';
import { FaEllipsisV, FaSignOutAlt, FaUser, FaSettings, FaHome } from 'react-icons/fa'; // Icons use kar rahe hain
import useAuth from '../../../configurations/auth/publicUsers/useAuth';
import { Link } from 'react-router-dom';

const PublicUserMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);
    const { authentication, logedOut } = useAuth()

    // Bahar click karne par menu band ho jaye
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="relative" ref={menuRef}>
            {/* Three Dots Button */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="p-2 rounded-full hover:bg-slate-100 transition-colors duration-200 text-slate-500 active:scale-90"
            >
                <FaEllipsisV className="text-lg" />
            </button>

            {/* Dropdown Menu (Material Elevation Style) */}
            {isOpen && (
                <div className="absolute right-0 mt-2 w-48 origin-top-right rounded-b-2xl bg-white shadow-2xl ring-1 ring-black ring-opacity-5 z-50 overflow-hidden animate-in fade-in zoom-in duration-150 border-t-4 border-brand-400">
                    <div className="py-2">
                        {/* Other Options (Optional) */}
                        <div className="flex w-full items-center px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 transition-colors">
                            <FaUser className="mr-3 text-slate-400" /> {authentication.data.fullName? authentication.data.fullName:authentication.data.phoneNo}
                        </div>

                        <hr className="my-1 border-slate-200" />

                        <Link to={"/"} className="flex w-full items-center px-4 py-3 text-sm text-slate-700 hover:bg-slate-50 transition-colors">
                            <FaHome className="mr-3 text-brand-400" /> Home
                        </Link>

                        <hr className="my-1 border-slate-200" />

                        {/* Logout Option */}
                        <button
                            onClick={() => {
                                setIsOpen(false);
                                logedOut();
                            }}
                            className="flex w-full items-center px-4 py-3 text-sm text-rose-600 font-medium hover:bg-rose-50 transition-colors"
                        >
                            <FaSignOutAlt className="mr-3 opacity-80" />
                            Logout
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PublicUserMenu;